import styled, { css } from 'styled-components';

export const PlusMinusStyled = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  label:first-child {
    height: 44px;
    display: flex;
    flex-direction: column;
    padding-top: 4.5px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
`;

export const PlusminusLabel = styled.div`
  ${({ theme }) => theme.kallisto.mixins.font('Body')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
`;
export const PlusminusSubLabel = styled.div`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
`;

export const PlusMinusContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .plus-minus-minus,
  .plus-minus-plus {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 22px;
    color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
    user-select: none;
    cursor: pointer;
    border: 1px solid transparent;
    transition: border-color 0.2s ease-in-out;
    outline: none;
    background: transparent;

    @media (min-width: 768px) {
      &:hover,
      :focus {
        color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
      }
    }

    &.active {
      box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.smallDownShadow};
    }

    &.disabled {
      border-color: transparent;
      background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};

      &:focus {
        border-color: transparent;
      }
    }
  }

  input {
    ${({ theme }) => theme.kallisto.mixins.font('Body')};
    color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
    text-align: center;
    width: 40px;
    border: none;
    padding: 0;
    margin: 0;
    outline: none;
    background: transparent;
  }
`;
